import { render, staticRenderFns } from "./perform-billing-button.vue?vue&type=template&id=3663394b&scoped=true&"
import script from "./perform-billing-button.vue?vue&type=script&lang=ts&"
export * from "./perform-billing-button.vue?vue&type=script&lang=ts&"
import style0 from "./perform-billing-button.vue?vue&type=style&index=0&id=3663394b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663394b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
